module.exports = __webpack_public_path__ + "static/media/course_05.0b1b69bb.jpg";